export default "__VITE_ASSET__blhctdMA__"